// extracted by mini-css-extract-plugin
export default {"svgContainer":"SvgContainer3_svgContainer__qOMTR","whiteSvg":"SvgContainer3_whiteSvg__ZF9Va"};